"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liveDisruptionsTrackerSupply = void 0;
const liveDisruptionsTrackerSupply = exports.liveDisruptionsTrackerSupply = {
  LIVE_DISRUPTIONS_TRACKER_SUPPLY: {
    en: {
      title: 'Live Disruptions Tracker',
      subtitle: 'Insight into global disruptions',
      description: 'The ICIS Live Disruptions Tracker gives insight into the disruptions impacting your commodity of interest, in one dynamic interface:',
      list: ['Global disruptions', 'Updated by market experts located in regions across the world', 'Tracking unscheduled shutdowns, scheduled shutdowns, upcoming new capacity and contractions.']
    },
    zh: {
      title: '实时中断追踪',
      subtitle: '洞悉全球装置生产中断情况',
      description: '通过ICIS实时中断追踪的动态交互界面，洞悉装置生产中断对您所关心的品目产生的影响：',
      list: ['全球装置生产中断情况', '遍布全球各地的市场专家实时进行更新', '追踪计划外与计划内停车、未来新产能投产与缩减']
    }
  }
};